import m from 'mithril';
import { readFileSync } from 'fs';

const faChevronLeft = readFileSync(__dirname + "/../public/imgs/icons/chevron-left-solid.svg", "utf8");
const faChevronRight = readFileSync(__dirname + "/../public/imgs/icons/chevron-right-solid.svg", "utf8");
const VerifiedBadge = readFileSync(__dirname + "/../public/imgs/icons/ijf_verified_badge.svg", "utf8");

function slider_portrait(items){

    let itemWidth = 0;
    let offsetLeft = 0;
    let sliderOffset = 0;
    let offsetArrowRightHide = 0;
    let touchStartX = null;
    let touchStartY = null;
    let touchStartOffsetLeft = 0;
    let touchXSpeed = 0;
    let touchStartXTs = null;
    let touchStartItemNb = null;
    let screenWidth = 0;
    let itemsPerPage = 4;
    let itemOffset = 0;
    let itemsStyle = {
        "transform": "translateX(" + sliderOffset + "px)"
    }

    return {
        oncreate : function(vnode){
            itemWidth = vnode.dom.querySelector('.item').offsetWidth;
            offsetLeft = vnode.dom.querySelector('.slider__container').offsetWidth;
            offsetArrowRightHide = items.length * itemWidth * -1;
            screenWidth = window.screen.width;
            if(screenWidth > 1200){
                itemsPerPage = 5;
            }else if(screenWidth > 900){
                itemsPerPage = 4;
            }else if(screenWidth > 640){
                itemsPerPage = 3;
            }else{
                itemsPerPage = 1;
            }
            m.redraw()
        },
        view : function(vnode){

            itemsStyle['transform'] = "transform: translateX(" + sliderOffset + "px)"

            return m('div.slider__outer-container', {
                /*ontouchstart : function(e){
                    touchStartX = e.touches[0].clientX
                    touchStartY = e.touches[0].clientY
                    touchStartOffsetLeft = sliderOffset
                    touchStartItemNb = Math.abs(Math.round(sliderOffset / itemWidth))
                    touchStartXTs = Date.now()
                    itemsStyle['transition'] = 'transition: none'
                },
                ontouchmove : function(e){
                    if(touchStartY - e.touches[0].clientY < 40){
                        sliderOffset = touchStartOffsetLeft - (touchStartX - e.touches[0].clientX)
                    }else{
                        sliderOffset = touchStartOffsetLeft
                    }
                },
                ontouchend : function(e){
                    if(sliderOffset > 0){
                        sliderOffset = 0
                    }
                    let currentDiffPx = touchStartOffsetLeft - sliderOffset;
                    let item_nb = Math.abs(Math.round(sliderOffset / itemWidth))
                    item_nb += Math.floor(touchXSpeed)
                    if(touchStartItemNb == item_nb){
                        if(Math.abs(currentDiffPx) > 100){
                            if(currentDiffPx < 0){
                                item_nb--;
                            }else{
                                item_nb++;
                            }
                        }
                    }
                    //  console.log(item_nb, items.length)
                    if(item_nb < 0){
                        item_nb = 0;
                    }else if(item_nb >= items.length){
                        item_nb = items.length-1;
                    }
                    sliderOffset = -1 * (item_nb * (itemWidth+20))
                    delete itemsStyle['transition']
                }*/
            },[
                m('div.slider__container',
                    m("ol.slider__items", {
                            "style": Object.values(itemsStyle).join(';') + ';'
                        },
                        items.map(function(__item){
                            return m("a.item.item--portrait",
                                {
                                    href: __item.view_href
                                },
                                [
                                    m("div.item__image",
                                        [
                                            m("div.item__image__background", [
                                               m("img[src='https://78884ca60822a34fb0e6-082b8fd5551e97bc65e327988b444396.ssl.cf3.rackcdn.com/profiles/350/" + __item.id_person + ".jpg']")
                                            ])
                                        ]
                                    ),
                                    m("div.item__texts",
                                        [
                                            m("div.item__title", [
                                                __item.display_name,
                                                __item.verified*1 != 0 && m("div.item__verified",
                                                    m.trust(VerifiedBadge)
                                                )
                                            ]),
                                            m("div.item__country", [
                                                m("img.country-ico[src='https://78884ca60822a34fb0e6-082b8fd5551e97bc65e327988b444396.ssl.cf3.rackcdn.com/flags/40x30/" + __item.country_short.toLowerCase() + ".png']"),
                                                __item.country_long
                                            ])
                                        ]
                                    )
                                ]
                            )
                        })
                    )
                ),
                itemOffset > 1 && m('div.slider__left-button', {
                    onclick : function(){
                        // sliderOffset += (itemsPerPage*(itemWidth+20)) // document.documentElement.clientWidth - offsetLeft;
                        itemOffset -= itemsPerPage;
                        sliderOffset = (itemOffset* -1 *(itemWidth+20))
                    }
                }, m.trust(faChevronLeft)),
                itemOffset < (items.length - itemsPerPage) && m('div.slider__right-button', {
                    onclick : function(){
                        // sliderOffset -= (itemsPerPage*(itemWidth+20)) // document.documentElement.clientWidth - offsetLeft;
                        itemOffset += itemsPerPage;
                        sliderOffset = (itemOffset* -1 *(itemWidth+20))
                    }
                }, m.trust(faChevronRight))
            ])
        }
    }
}

export default slider_portrait;
